export default __webpack_public_path__ + "static/media/jwt.19ed33c7.png";